import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const SfFigureWalkIcon = props => /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 14 23",
  ...props,
  children: /*#__PURE__*/_jsx("path", {
    fill: "currentColor",
    d: "m1.711 21.403 2.976-3.537c.292-.35.345-.435.462-.8l.183-.568-1.635-2.051-.468 2.158L.3 20.075c-.96 1.153.622 2.278 1.411 1.328Zm7.184-.302c.63 1.274 2.51.486 1.827-.898l-2.015-4.08a8.383 8.383 0 0 0-.558-.918L6.884 13.41l.083-.25c.33-1.037.468-1.651.544-2.668l.199-2.857c.1-1.382-.723-2.418-2.128-2.418-1.05 0-1.771.533-2.73 1.473l-1.514 1.49c-.496.486-.66.889-.711 1.545l-.18 2.334c-.052.61.292 1.042.853 1.062.574.04.925-.303.975-.949L2.5 9.626l.69-.623c.246-.22.568-.077.554.185l-.154 2.12c-.088 1.09.16 1.627.927 2.583l2.006 2.51c.193.253.216.347.306.51l2.066 4.19Zm3.467-12.027h-2.267L8.716 7.545l-.175 2.465.486.483c.323.323.609.426 1.21.426h2.125c.615 0 1.024-.351 1.024-.923 0-.553-.42-.922-1.024-.922ZM6.703 4.379c1.206 0 2.181-.985 2.181-2.19A2.181 2.181 0 0 0 6.704 0C5.49 0 4.512.975 4.512 2.189c0 1.205.977 2.19 2.19 2.19Z"
  })
});
export default SfFigureWalkIcon;